export default __webpack_public_path__ + "static/media/aus-map.1331882d.jpg";